var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
        _vm._v("油品优惠价差报表")
      ]),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("span", { staticClass: "demonstration" }, [_vm._v("选择日期")]),
          _c("el-date-picker", {
            staticStyle: { width: "20rem !important" },
            attrs: {
              editable: false,
              size: "small",
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "timestamp",
              "picker-options": _vm.pickerOptionsLimit
            },
            model: {
              value: _vm.datePickerValue,
              callback: function($$v) {
                _vm.datePickerValue = $$v
              },
              expression: "datePickerValue"
            }
          }),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "primary"
              },
              on: { click: _vm.loadData }
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "warning",
                icon: "el-icon-document"
              },
              on: {
                click: function($event) {
                  return _vm.exportExcel(_vm.excelSheets, "油品优惠价差报表")
                }
              }
            },
            [_vm._v(" 下载报表 ")]
          )
        ],
        1
      ),
      _c("br"),
      _c(
        "el-table",
        {
          ref: "stationDailyDiscountData",
          attrs: {
            id: "stationDailyDiscountData",
            data: _vm.stationDailyDiscountData,
            "highlight-current-row": "",
            height: "600",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "cell-style": _vm.cellStyle,
            "header-cell-style": { "text-align": "center" },
            border: ""
          },
          on: { "filter-change": _vm.filterChange }
        },
        [
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "站点" } },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  label: _vm.selectedArea,
                  align: "center",
                  "column-key": "area",
                  filters: _vm.filterMapping,
                  "filter-multiple": false,
                  "filter-placement": "right",
                  "filter-method": _vm.filterHandler
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.sellerName(scope.row.sellerId)) + " "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "汇总" } },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayNums",
                  width: "120px",
                  label: "总升数"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumDiscount",
                  width: "120px",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffDiscountPrice",
                  label: "总均价"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "0#柴油" } },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayNums0",
                  width: "120px",
                  label: "总升数"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumDiscount0",
                  width: "120px",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffDiscountPrice0",
                  label: "优惠均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumExtraDiscount0",
                  label: "直降优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumUserDiscount0",
                  label: "会员优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumSvcDiscount0",
                  label: "卡优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumPlatformDiscount0",
                  label: "平台优惠"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "92#汽油" } },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayNums92",
                  width: "120px",
                  label: "总升数"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumDiscount92",
                  width: "120px",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffDiscountPrice92",
                  label: "优惠均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumExtraDiscount92",
                  label: "直降优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumUserDiscount92",
                  label: "会员优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumSvcDiscount92",
                  label: "卡优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumPlatformDiscount92",
                  label: "平台优惠"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { align: "center", label: "95#汽油" } },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayNums95",
                  width: "120px",
                  label: "总升数"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumDiscount95",
                  width: "120px",
                  label: "总优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "dayDiffDiscountPrice95",
                  label: "优惠均价"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumExtraDiscount95",
                  label: "直降优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumUserDiscount95",
                  label: "会员优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumSvcDiscount95",
                  label: "卡优惠"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "daySumPlatformDiscount95",
                  label: "平台优惠"
                }
              })
            ],
            1
          ),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "dayCapitalAmount",
              label: "中深出资"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }